import ua from '@/utils/ua'
import TaskResultModal from '@/components/TaskResultModal'

export default {
  components: {
    TaskResultModal
  },
  data() {
    return {
      fitWapRouteList: ['/tool/googlecontact', '/tool/outlookcontact', '/tool/export'],
      privilegeInfo: {}
    }
  },
  computed: {
    isHide() {
      const path = this.$route.path
      return this.fitWapRouteList.includes(path) && ua.wap
    }
  },
  methods: {
    go(path) {
      this.$router.push({ path })
    },
    getPrivilegeInfo() {
      this.privilegeInfo = this.$store.state.user?.user_info?.privilege_info || {}
    }
  },
  mounted() {
    this.getPrivilegeInfo()
  }
}
